export const DEFAULT_DISPLAY_TIME = 10;  // Seconds